const translations = {
  "en": {
    "5 moves get you there sooner": "5 moves get you there sooner",
    "Age, income, the basics — about a minute.": "Age, income, the basics — about a minute.",
    "Bring single-name concentration into your 15% guardrail, staged over 6 months.": "Bring single-name concentration into your 15% guardrail, staged over 6 months.",
    "Complete this plan": "Complete this plan",
    "Compounding your investments": "Compounding your investments",
    "Continue": "Continue",
    "Control": "Control",
    "financial fitness score": "financial fitness score",
    "Financial fitness score": "Financial fitness score",
    "Finding people on your path": "Finding people on your path",
    "Free for 7 days · cancel anytime": "Free for 7 days · cancel anytime",
    "Get my score": "Get my score",
    "Goal for you": "Goal for you",
    "Good to meet you, %{var0}. Just a little about you first.": "Good to meet you, %{var0}. Just a little about you first.",
    "Growth": "Growth",
    "Hmm — I hit a snag.": "Hmm — I hit a snag.",
    "I crunch the numbers while you wait.": "I crunch the numbers while you wait.",
    "I read your money in the background": "I read your money in the background",
    "I'll read": "I'll read",
    "I'll read your money": "I'll read your money",
    "I'm Ed — your money person.": "I'm Ed — your money person.",
    "in 90 seconds.": "in 90 seconds.",
    "Let's go": "Let's go",
    "Meet your": "Meet your",
    "One clear target, built around you.": "One clear target, built around you.",
    "One number for how your money's really doing.": "One number for how your money's really doing.",
    "Pinpointing your $1M year": "Pinpointing your $1M year",
    "Reading your income & savings": "Reading your income & savings",
    "Reading your money": "Reading your money",
    "Safety": "Safety",
    "See where you're headed": "See where you're headed",
    "Try again": "Try again",
    "Unlock my full plan": "Unlock my full plan",
    "What this plan does for your score": "What this plan does for your score",
    "What's in your score": "What's in your score",
    "You answer a few quick questions": "You answer a few quick questions",
    "You get a goal worth chasing": "You get a goal worth chasing",
    "You get your Fitness Score": "You get your Fitness Score",
    "Your answers are safe — nothing's lost.": "Your answers are safe — nothing's lost.",
    "Your cushion if a shock hits": "Your cushion if a shock hits",
    "Your Financial fitness score": "Your Financial fitness score",
    "your money": "your money",
    "Your money building": "Your money building",
    "Your monthly cash flow": "Your monthly cash flow",
    "Your Plan": "Your Plan",
    "Your starting number — and a goal to lift it.": "Your starting number — and a goal to lift it."
  },
  "zh-tw": {
    "5 moves get you there sooner": "5 項操作助你更快達標",
    "Age, income, the basics — about a minute.": "年齡、收入等基本資料，約需一分鐘。",
    "Bring single-name concentration into your 15% guardrail, staged over 6 months.": "將個股集中度調整至你的 15% 控管區間內，並分階段於 6 個月內完成。",
    "Complete this plan": "完成此計畫",
    "Compounding your investments": "投資複利成長",
    "Continue": "繼續",
    "Control": "掌控力",
    "financial fitness score": "財務健康分數",
    "Financial fitness score": "財務健康分數",
    "Finding people on your path": "尋找你路上的夥伴",
    "Free for 7 days · cancel anytime": "7 天免費體驗 · 隨時取消",
    "Get my score": "取得我的評分",
    "Goal for you": "你的目標",
    "Good to meet you, %{var0}. Just a little about you first.": "很高興認識你，%{var0}。先簡單了解你的情況。",
    "Growth": "成長",
    "Hmm — I hit a snag.": "嗯——目前遇到些狀況。",
    "I crunch the numbers while you wait.": "你等待期間，我會把數字都算好。",
    "I read your money in the background": "我會在背景持續讀你的錢",
    "I'll read": "正在讀取",
    "I'll read your money": "我來讀你的錢",
    "I'm Ed — your money person.": "我是 Ed — 你的理財專家。",
    "in 90 seconds.": "在 90 秒內。",
    "Let's go": "開始",
    "Meet your": "認識你的",
    "One clear target, built around you.": "一個明確目標，為你量身打造。",
    "One number for how your money's really doing.": "一個數字，掌握你的資金實際表現。",
    "Pinpointing your $1M year": "精準規劃你的百萬目標年",
    "Reading your income & savings": "正在讀取你的收入與儲蓄",
    "Reading your money": "正在分析你的資產",
    "Safety": "安全性",
    "See where you're headed": "查看你的目標進度",
    "Try again": "重試",
    "Unlock my full plan": "解鎖我的完整計畫",
    "What this plan does for your score": "此計畫如何影響你的評分",
    "What's in your score": "你的評分由哪些項目組成",
    "You answer a few quick questions": "回答幾個快速問題",
    "You get a goal worth chasing": "擁有值得追求的目標",
    "You get your Fitness Score": "取得你的財務健康分數",
    "Your answers are safe — nothing's lost.": "你的回答已安全保存 — 不會遺失。",
    "Your cushion if a shock hits": "市場衝擊時的緩衝",
    "Your Financial fitness score": "你的財務健康分數",
    "your money": "你的資金",
    "Your money building": "你的財富累積",
    "Your monthly cash flow": "你的每月現金流",
    "Your Plan": "你的計畫",
    "Your starting number — and a goal to lift it.": "你的起始數字，以及提升它的目標。"
  }
};

export default translations;
